export enum PowerBiReportEntityType {
    Utility = "1",
    Program = "2",
    Application = "3",
}
